import { useEffect, useState } from "react";
import { useOrganization } from "../../api/Organizations";
import Loading from "../../components/Loading";
import { ContentTitle, PageSection } from "../../layout/ContentLayout";
import OrganizationSettings from "./Forms/OrganizationSettings";
import OrganizationLimits from "./Forms/OrganizationLimits";
import OrganizationBilling from "./Forms/OrganizationBilling";

const Settings = ({ organizationId }) => {
  const [organization, setOrganization] = useState();
  const organizationData = useOrganization(organizationId);

  useEffect(() => {
    if (organizationData?.data?.Organization) {
      setOrganization(organizationData?.data?.Organization);
    }
  }, [organizationData]);

  return !organization ? (
    <Loading />
  ) : (
    <>
      <ContentTitle>Settings</ContentTitle>
      <PageSection title="My Form">
        <OrganizationSettings organization={organization} />
      </PageSection>

      <PageSection title="Limits">
        <OrganizationLimits organizationId={organizationId} />
      </PageSection>

      <PageSection title="Billing Information">
        <OrganizationBilling organizationId={organizationId} />
      </PageSection>
    </>
  );
};

export default Settings;
